import { format, parseISO, isValid } from "date-fns";

interface DateProps {
    date: string;
}

const SimpleDate: React.FC<DateProps> = ({ date }) => {
    if (!date || date.trim() === "") {
        return <span>N/A</span>;
    }

    try {
        // Try parsing as ISO string first
        let parsedDate = parseISO(date);
        
        // If that fails, try creating a new Date object
        if (!isValid(parsedDate)) {
            parsedDate = new Date(date);
            if (isNaN(parsedDate.getTime())) {
                return <span>Invalid Date</span>;
            }
        }

        return (
            <span className="whitespace-nowrap">
                {/* Full date on medium+ screens */}
                <span className="hidden md:inline">
                    {format(parsedDate, "PPP")} · {format(parsedDate, " p")}
                </span>
                {/* Short date on small screens: DD/MM/YYYY with same time */}
                <span className="inline md:hidden">
                    {format(parsedDate, "dd/MM/yyyy")} · {format(parsedDate, " p")}
                </span>
            </span>
        );
    } catch (error) {
        return <span>Invalid Date</span>;
    }
};

export default SimpleDate;